import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const PortRecordingTimer = ({ 
  isActive, 
  onComplete, 
  onCancel, 
  portNumber,
  className = '',
  style = {},
  initialTimeLeft
}) => {
  const [timeLeft, setTimeLeft] = useState(initialTimeLeft !== undefined ? initialTimeLeft : 10 * 60); // 10 minutes in seconds
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isActive && !isRunning) {
      setIsRunning(true);
      if (initialTimeLeft !== undefined) {
        setTimeLeft(initialTimeLeft);
      } else {
        setTimeLeft(10 * 60);
      }
    } else if (!isActive && isRunning) {
      setIsRunning(false);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
  }, [isActive, isRunning, initialTimeLeft]);

  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime <= 1) {
            setIsRunning(false);
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            onComplete && onComplete();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isRunning, timeLeft, onComplete]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const handleCancel = () => {
    setIsRunning(false);
    setTimeLeft(10 * 60);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    onCancel && onCancel();
  };

  if (!isActive) {
    return null;
  }

  return (
    <div 
      className={`port-recording-timer ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        marginRight: '10px',
        fontWeight: '500',
        color: '#495057',
        ...style
      }}
    >
      <div style={{ color: '#FF0004', fontWeight: 'bold' }}>
        Port Recording Enabled | {formatTime(timeLeft)}
      </div>
      <button
        onClick={handleCancel}
        style={{
          background: 'none', 
          border: 'none',
          color: '#dc3545',
          cursor: 'pointer',
          fontSize: '12px',
          textDecoration: 'underline'
        }}
      >
        Cancel
      </button>
    </div>
  );
};

PortRecordingTimer.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
  portNumber: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  initialTimeLeft: PropTypes.number
};

export default PortRecordingTimer; 